import * as React from "react";

const SvgPaypal = ({ active }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 512 512"
    style={{
      enableBackground: "new 0 0 512 512",
      width: "50px",
      height: "50px",
      marginBottom: "15px",
    }}
    xmlSpace="preserve"
  >
    <path
      style={{
        fill: active === 5 ? "#385c8e" : "white",
      }}
      d="M474.348 89.297c20.796 38.137 13.933 83.11 5.743 109.688-44.321 144.772-244.304 136.897-273.235 136.897-28.897 0-35.627 26.947-35.627 26.947l-21.606 94.263c-5.89 33.087-35.896 31.439-35.896 31.439H48.633c-1.637 0-3.164-.113-4.567-.316-.323 6.059.539 23.771 22.2 23.771h65.074s30.007 1.683 35.917-31.403l21.583-94.259s6.753-26.948 35.651-26.948c28.884 0 228.914 7.873 273.257-136.904 9.892-32.36 17.935-91.819-23.4-133.175z"
    />
    <path
      style={{
        fill: active === 5 ? "#385c8e" : "white",
      }}
      d="m129.523 436.545 21.603-94.266s6.711-26.901 35.651-26.901c28.873 0 228.89 7.832 273.214-136.909C476.21 125.55 487.47.009 285.513.009H139.638s-30.321-1.408-37.803 30.829L6.521 442.196s-4.093 25.778 21.987 25.778h65.116s30.008 1.696 35.899-31.429zM184.5 197.259l19.371-83.589s6.17-22.731 26.104-26.097c19.913-3.378 53.834.601 62.56 2.248 56.65 10.639 44.6 64.239 44.6 64.239-11.216 82.738-140.003 71.257-140.003 71.257-20.193-7.301-12.632-28.058-12.632-28.058z"
    />
  </svg>
);

export default SvgPaypal;
